module.exports = __webpack_public_path__ + "static/media/play-icon-green-bg.3a86eb1a.png";